import Cookies from 'js-cookie';

const TokenKey = 'token'
const domain = ''

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, {path: '/', domain: domain})
}

export function removeToken() {
  return Cookies.remove(TokenKey, {path: '/', domain: domain})
}

export function getCookie(key) {
  return Cookies.get(key)
}

export function setCookie(key, vale) {
  return Cookies.set(key, vale)
}

export function removeCookie(key) {
  return Cookies.remove(key)
}


// WEBPACK FOOTER //
// ./src/utils/auth.js